import { useMutation, useQueryClient } from "@tanstack/react-query";
import { httpClient } from "@/shared/api/http-client";
import type { CreateTierInput, SubscriptionTierConfig } from "./types";
import { SUBSCRIPTION_TIERS_QUERY_KEY } from "./constants";

/** `POST /api/admin/subscription-tiers` (API-CAP-2). */
async function createTier(input: CreateTierInput): Promise<SubscriptionTierConfig> {
  return httpClient<SubscriptionTierConfig>("/api/admin/subscription-tiers", {
    method: "POST",
    headers: { "content-type": "application/json" },
    body: JSON.stringify(input),
  });
}

export function useCreateTier() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: createTier,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: SUBSCRIPTION_TIERS_QUERY_KEY });
    },
  });
}
